/* DEADLINE theme interactions */
(function () {
  'use strict';

  var FIG_STATIC = location.hash.indexOf('figstatic') !== -1;
  if (FIG_STATIC) document.documentElement.classList.add('fig-static');

  function initTabs(root) {
    if (root.dataset.dlInit) return;
    root.dataset.dlInit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.probs__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.probs__panel'));

    function activate(i) {
      tabs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      panels.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i); });
    });
    activate(0);
  }

  function initFcard(card) {
    if (card.dataset.dlInit) return;
    card.dataset.dlInit = '1';
    card.addEventListener('click', function () {
      if (window.matchMedia('(hover: none)').matches) {
        card.classList.toggle('is-open');
      }
    });
  }

  function initTimeline(root) {
    if (FIG_STATIC) return;
    if (root.dataset.dlInit) return;
    root.dataset.dlInit = '1';
    var wrap = root.querySelector('.timeline__stage-wrap');
    var stage = root.querySelector('.timeline__stage');
    var unit = root.querySelector('[data-tl-unit]');
    var isPhotosLayout = root.classList.contains('timeline--photos');
    var stages;
    try { stages = JSON.parse(root.querySelector('[data-tl-stages]').textContent); }
    catch (e) { return; }
    if (!wrap || !stage || !unit || !stages.length) return;
    var current = -1;
    var animating = false;
    var pendingTarget = -1;
    var ticking = false;

    function fill(u, s) {
      u.querySelector('[data-tl-day]').textContent = s.day;
      u.querySelector('[data-tl-head]').textContent = s.title;
      u.querySelector('[data-tl-body]').textContent = s.body;
    }

    /* Per the "What to expect" reference: the whole stage unit (dot, day,
       card, caption) slides along the rail — incoming rises desaturated
       (salmon) from below and snaps to full red as it settles; outgoing
       fades while exiting upward. Reversed when scrolling back. */
    function setStage(i, instant) {
      i = Math.min(stages.length - 1, Math.max(0, i));
      if (i === current) return;
      if (animating) { pendingTarget = i; return; }
      if (instant || current < 0) {
        current = i;
        root.dataset.tlCurrent = String(i);
        fill(unit, stages[i]);
        return;
      }
      var dir = i > current ? 1 : -1;
      current = i;
      root.dataset.tlCurrent = String(i);
      animating = true;

      var incoming = unit.cloneNode(true);
      fill(incoming, stages[i]);
      incoming.className = 'timeline__unit is-desat ' + (dir > 0 ? 'enter-below' : 'enter-above');
      stage.appendChild(incoming);
      var outgoing = unit;
      unit = incoming;

      incoming.getBoundingClientRect(); // flush layout so the enter state paints
      incoming.classList.add('is-anim');
      outgoing.classList.add('is-anim');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          incoming.classList.remove('enter-below', 'enter-above');
          outgoing.classList.add('is-desat', dir > 0 ? 'leave-up' : 'leave-down');
        });
      });
      setTimeout(function () { incoming.classList.remove('is-desat'); }, 380);
      setTimeout(function () {
        if (outgoing.parentNode) outgoing.parentNode.removeChild(outgoing);
        incoming.classList.remove('is-anim');
        animating = false;
        if (pendingTarget >= 0 && pendingTarget !== current) {
          var t = pendingTarget;
          pendingTarget = -1;
          setStage(t);
        } else {
          pendingTarget = -1;
        }
      }, 700);
    }

    function computeStage() {
      var rect = wrap.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var scrolled = Math.min(Math.max(-rect.top, 0), total);
      var p = total > 0 ? scrolled / total : 0;
      return Math.min(stages.length - 1, Math.floor(p * stages.length));
    }

    function onScroll() {
      if (!isPhotosLayout && window.matchMedia('(min-width: 1024px)').matches) return;
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        setStage(computeStage());
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    setStage(!isPhotosLayout && window.matchMedia('(min-width: 1024px)').matches ? 0 : computeStage(), true);

    /* The homepage timeline is a finite desktop scroll chapter. Its first
       vertical gesture centers the complete Figma scene without changing the
       day; later gestures advance one animated day at a time. Scrolling back
       reverses the same sequence, and an outward gesture at either endpoint
       releases the page immediately. Tablet and mobile retain the existing
       native sticky, scroll-synced timeline. */
    var classicWheelDelta = 0, classicWheelLocked = false;
    var classicCaptured = false, classicReleaseDirection = 0;
    var classicWheelUnlock = null;

    function isClassicDesktop() {
      return !isPhotosLayout && window.matchMedia('(min-width: 1024px)').matches;
    }

    function getClassicTimelineTop() {
      var rect = root.getBoundingClientRect();
      var referenceHeight = 841;
      var visibleTop = Math.max(0, Math.round((window.innerHeight - referenceHeight) / 2));
      return Math.max(0, window.scrollY + rect.top - visibleTop);
    }

    function isClassicTimelineNear(direction) {
      var rect = root.getBoundingClientRect();
      if (direction > 0) {
        return rect.top <= window.innerHeight * .62 && rect.bottom > window.innerHeight * .28;
      }
      return rect.bottom >= window.innerHeight * .38 && rect.top < window.innerHeight * .72;
    }

    function lockClassicWheelFor(ms) {
      classicWheelLocked = true;
      if (classicWheelUnlock) window.clearTimeout(classicWheelUnlock);
      classicWheelUnlock = window.setTimeout(function () { classicWheelLocked = false; }, ms);
    }

    function onClassicTimelineWheel(e) {
      if (!isClassicDesktop() || e.ctrlKey || !e.deltaY || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      var direction = e.deltaY > 0 ? 1 : -1;

      if (!classicCaptured) {
        if (classicReleaseDirection === direction) return;
        if (classicReleaseDirection && classicReleaseDirection !== direction) classicReleaseDirection = 0;
        if (!isClassicTimelineNear(direction)) return;
        e.preventDefault();
        setStage(direction > 0 ? 0 : stages.length - 1, true);
        classicCaptured = true;
        classicWheelDelta = 0;
        lockClassicWheelFor(620);
        window.scrollTo({ top: getClassicTimelineTop(), behavior: 'smooth' });
        return;
      }

      var atClassicStart = direction < 0 && current === 0;
      var atClassicEnd = direction > 0 && current === stages.length - 1;
      if (atClassicStart || atClassicEnd) {
        classicCaptured = false;
        classicReleaseDirection = direction;
        classicWheelDelta = 0;
        return;
      }

      e.preventDefault();
      if (classicWheelLocked) return;
      if (classicWheelDelta && Math.sign(classicWheelDelta) !== direction) classicWheelDelta = 0;
      classicWheelDelta += e.deltaY;
      if (Math.abs(classicWheelDelta) < 40) return;
      classicWheelDelta = 0;
      setStage(current + direction);
      lockClassicWheelFor(720);
    }

    if (!isPhotosLayout) {
      window.addEventListener('wheel', onClassicTimelineWheel, { passive: false });
      window.addEventListener('scroll', function () {
        if (classicCaptured || !classicReleaseDirection) return;
        var rect = root.getBoundingClientRect();
        if (rect.bottom < -100 || rect.top > window.innerHeight + 100) classicReleaseDirection = 0;
      }, { passive: true });
      window.addEventListener('resize', function () {
        if (classicCaptured && isClassicDesktop()) {
          window.scrollTo({ top: getClassicTimelineTop(), behavior: 'auto' });
        }
      });
    }
  }

  /* Photos layout day rail: the card row (.tl2-cards) scrolls horizontally;
     the day rail below (.tl2-dayrow) tracks which card is most visible and
     highlights that day's dot + label. Click/keyboard on a day jumps the
     row to that card. Independent init flag from initTimeline (classic
     rail) since both can live on the same [data-timeline] root. */
  function initTimelinePhotos(root) {
    if (root.dataset.dlPhotoInit) return;
    root.dataset.dlPhotoInit = '1';
    var track = root.querySelector('[data-tl-cards]');
    var dayrow = root.querySelector('[data-tl-dayrow]');
    var dayCols = Array.prototype.slice.call(root.querySelectorAll('[data-tl-daycol]'));
    var cards = track ? Array.prototype.slice.call(track.querySelectorAll('.tl2-card')) : [];
    if (!track || !dayCols.length || !cards.length) return;

    var current = 0;

    function setActive(i) {
      if (i !== current) {
        current = i;
        dayCols.forEach(function (col, j) { col.classList.toggle('is-active', j === i); });
        if (dayrow) dayrow.style.setProperty('--tl-progress', dayCols.length > 1 ? String(i / (dayCols.length - 1)) : '0');
      }
    }

    function goTo(i) {
      var index = Math.min(cards.length - 1, Math.max(0, i));
      var target = cards[index];
      if (!target) return;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var targetLeft = target.offsetLeft - parseFloat(window.getComputedStyle(track).paddingLeft);
      setActive(index);
      track.scrollTo({ left: Math.min(maxScroll, Math.max(0, targetLeft)), behavior: 'smooth' });
    }

    function getStep() {
      if (cards.length < 2) return track.clientWidth || 1;
      var a = cards[0].getBoundingClientRect();
      var b = cards[1].getBoundingClientRect();
      return Math.max(1, b.left - a.left);
    }

    function computeIndex() {
      /* fully scrolled = last stage, even when the final card can't reach the
         track's left edge (viewport shows ~2 cards, so plain rounding would
         stop at the second-to-last stage) */
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll > 0 && track.scrollLeft >= maxScroll - 8) return cards.length - 1;
      var idx = Math.round(track.scrollLeft / getStep());
      return Math.min(cards.length - 1, Math.max(0, idx));
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        setActive(computeIndex());
      });
    }
    track.addEventListener('scroll', onScroll, { passive: true });

    dayCols.forEach(function (col, i) {
      function go() {
        goTo(i);
      }
      col.addEventListener('click', go);
      col.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          go();
        }
      });
    });

    /* On desktop, the timeline becomes a short, centered scroll chapter.
       Entry centers the full section first; following vertical gestures move
       one card at a time in either direction. The page is released only when
       the user scrolls outward from the first or final stage. */
    var wheelDelta = 0, wheelLocked = false;
    var timelineCaptured = false, releaseDirection = 0;
    var wheelUnlock = null;

    function getTimelineTop() {
      var rect = root.getBoundingClientRect();
      var centeredTop = Math.round((window.innerHeight - rect.height) / 2);
      var visibleTop = Math.max(16, centeredTop);
      return Math.max(0, window.scrollY + rect.top - visibleTop);
    }

    /* The chapter only works when the whole section (heading, cards, day
       rail) fits the viewport; on smaller windows the centering jump lands
       with the section cut off and the wheel trap feels broken, so those
       windows keep native scrolling. */
    function chapterFits() {
      return root.getBoundingClientRect().height + 32 <= window.innerHeight;
    }

    function isTimelineNear(direction) {
      var rect = root.getBoundingClientRect();
      if (direction > 0) {
        return rect.top <= window.innerHeight * .55 && rect.bottom > window.innerHeight * .35;
      }
      return rect.bottom >= window.innerHeight * .45 && rect.top < window.innerHeight * .65;
    }

    function lockWheelFor(ms) {
      wheelLocked = true;
      if (wheelUnlock) window.clearTimeout(wheelUnlock);
      wheelUnlock = window.setTimeout(function () { wheelLocked = false; }, ms);
    }

    function onTimelineWheel(e) {
      if (!window.matchMedia('(min-width: 1024px)').matches || e.ctrlKey || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      if (!chapterFits()) { timelineCaptured = false; return; }
      var direction = e.deltaY > 0 ? 1 : -1;

      if (!timelineCaptured) {
        if (releaseDirection === direction) return;
        if (releaseDirection && releaseDirection !== direction) releaseDirection = 0;
        if (!isTimelineNear(direction)) return;
        /* Entering toward an endpoint the row is already at (e.g. scrolling
           up past a section still on card 1) would center the page and then
           release on the very next gesture — a pointless snap. Skip it. */
        if ((direction < 0 && current === 0) || (direction > 0 && current === cards.length - 1)) return;
        e.preventDefault();
        timelineCaptured = true;
        wheelDelta = 0;
        lockWheelFor(600);
        window.scrollTo({ top: getTimelineTop(), behavior: 'smooth' });
        return;
      }

      var index = current;
      var atStart = direction < 0 && index === 0;
      var atEnd = direction > 0 && index === cards.length - 1;
      if (atStart || atEnd) {
        timelineCaptured = false;
        releaseDirection = direction;
        wheelDelta = 0;
        return;
      }
      e.preventDefault();
      if (wheelLocked) return;
      if (wheelDelta && Math.sign(wheelDelta) !== direction) wheelDelta = 0;
      wheelDelta += e.deltaY;
      if (Math.abs(wheelDelta) < 40) return;
      wheelDelta = 0;
      goTo(index + direction);
      lockWheelFor(480);
    }
    window.addEventListener('wheel', onTimelineWheel, { passive: false });
    window.addEventListener('scroll', function () {
      if (timelineCaptured || !releaseDirection) return;
      var rect = root.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > window.innerHeight + 100) releaseDirection = 0;
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!timelineCaptured) return;
      if (!chapterFits()) { timelineCaptured = false; return; }
      window.scrollTo({ top: getTimelineTop(), behavior: 'auto' });
    });

    /* Drag-to-scroll for desktop pointer users: no visible scrollbar or
       controls in the design, so mouse users also retain a grab-drag affordance.
       Touch/pen keep native scrolling untouched. */
    var isDown = false, startX = 0, startScroll = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      isDown = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      if (track.setPointerCapture) { try { track.setPointerCapture(e.pointerId); } catch (err) {} }
    });
    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });
    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('pointercancel', endDrag);

    setActive(computeIndex());
    if (dayrow) dayrow.style.setProperty('--tl-progress', dayCols.length > 1 ? String(current / (dayCols.length - 1)) : '0');
  }

  /* Mobile marquees use native horizontal scrolling, so a finger can take
     over at any point. Auto motion pauses during the gesture and resumes
     after a short idle window; reduced-motion users keep manual swipe only. */
  function initMobileMarquee(scroller) {
    if (FIG_STATIC || scroller.dataset.dlMobileMarqueeInit) return;
    var track = scroller.firstElementChild;
    var copy = track ? track.querySelector('[data-dl-marquee-copy]') : null;
    var copyFirst = copy ? copy.firstElementChild : null;
    var originalFirst = track ? track.firstElementChild : null;
    if (!track || !copyFirst || !originalFirst) return;
    scroller.dataset.dlMobileMarqueeInit = '1';

    var mobile = window.matchMedia('(max-width: 767px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var speed = parseFloat(scroller.dataset.dlMarqueeSpeed || '60');
    var direction = parseFloat(scroller.dataset.dlMarqueeDirection || '1') < 0 ? -1 : 1;
    var loopWidth = 0;
    var rafId = 0;
    var lastTs = 0;
    var isIntersecting = !('IntersectionObserver' in window);
    var gesturePaused = false;
    var resumeTimer = 0;
    var fractionalDistance = 0;

    function measure() {
      loopWidth = Math.max(0, copyFirst.offsetLeft - originalFirst.offsetLeft);
      if (direction < 0 && mobile.matches && loopWidth && scroller.scrollLeft < 1) {
        scroller.scrollLeft = loopWidth;
      }
    }

    function shouldRun() {
      return mobile.matches && !reducedMotion.matches && isIntersecting &&
        !document.hidden && !gesturePaused && loopWidth > 0;
    }

    function queueFrame() {
      if (!rafId && shouldRun()) rafId = window.requestAnimationFrame(frame);
    }

    function frame(ts) {
      rafId = 0;
      if (!shouldRun()) { lastTs = 0; return; }
      var dt = lastTs ? Math.min(ts - lastTs, 64) : 0;
      lastTs = ts;
      fractionalDistance += direction * speed * dt / 1000;
      var wholePixels = fractionalDistance < 0 ? Math.ceil(fractionalDistance) : Math.floor(fractionalDistance);
      fractionalDistance -= wholePixels;
      if (wholePixels) scroller.scrollLeft += wholePixels;
      if (direction > 0 && scroller.scrollLeft >= loopWidth) {
        scroller.scrollLeft -= loopWidth;
      } else if (direction < 0 && scroller.scrollLeft <= 0) {
        scroller.scrollLeft += loopWidth;
      }
      queueFrame();
    }

    function sync() {
      if (shouldRun()) {
        queueFrame();
      } else {
        if (rafId) window.cancelAnimationFrame(rafId);
        rafId = 0;
        lastTs = 0;
      }
    }

    function pauseForGesture() {
      gesturePaused = true;
      fractionalDistance = 0;
      if (resumeTimer) window.clearTimeout(resumeTimer);
      sync();
    }

    function resumeAfterGesture() {
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        gesturePaused = false;
        sync();
      }, 900);
    }

    scroller.addEventListener('pointerdown', pauseForGesture);
    scroller.addEventListener('pointerup', resumeAfterGesture);
    scroller.addEventListener('pointercancel', resumeAfterGesture);
    scroller.addEventListener('wheel', function () {
      pauseForGesture();
      resumeAfterGesture();
    }, { passive: true });

    function onViewportChange() {
      window.requestAnimationFrame(function () {
        measure();
        sync();
      });
    }
    window.addEventListener('resize', onViewportChange, { passive: true });
    if (mobile.addEventListener) mobile.addEventListener('change', onViewportChange);
    else if (mobile.addListener) mobile.addListener(onViewportChange);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', sync);
    else if (reducedMotion.addListener) reducedMotion.addListener(sync);
    document.addEventListener('visibilitychange', sync);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        isIntersecting = entries[0] ? entries[0].isIntersecting : true;
        sync();
      }, { rootMargin: '100px 0px', threshold: 0 });
      observer.observe(scroller);
    }

    measure();
    sync();
  }

  function initFaqItem(item) {
    if (item.dataset.dlInit) return;
    item.dataset.dlInit = '1';
    var btn = item.querySelector('.faq__q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      item.classList.toggle('is-open');
    });
  }

  /* Checker trail effect (rAF, time-based) */
  function initChecker(canvas) {
    if (FIG_STATIC || canvas.dataset.dlInit) return;
    canvas.dataset.dlInit = '1';
    var ctx = canvas.getContext('2d');
    var conf = {
      cell: parseInt(canvas.dataset.cell || '70', 10),
      colors: (canvas.dataset.colors || 'rgba(218,34,9,0.08)').split('|')
    };
    var W, H, cols, rows, cells = [];
    var running = false;
    var isIntersecting = false;
    var rafId = 0;
    var lastTs = 0;
    var lastPaintTs = 0;
    var spawnAcc = 0;
    var SPAWN_EVERY = 420;
    var HALF_LIFE = 900;
    var FRAME_INTERVAL = 1000 / 30;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function resize() {
      var r = canvas.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(1, Math.round(r.width));
      H = Math.max(1, Math.round(r.height));
      canvas.width = Math.round(W * dpr);
      canvas.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      cols = Math.ceil(W / conf.cell);
      rows = Math.ceil(H / conf.cell);
      cells = new Array(cols * rows);
      for (var i = 0; i < cells.length; i++) cells[i] = 0;
    }
    resize();
    window.addEventListener('resize', resize);

    function queueFrame() {
      if (!rafId) rafId = requestAnimationFrame(frame);
    }

    function frame(ts) {
      rafId = 0;
      if (!running) return;
      if (lastPaintTs && ts - lastPaintTs < FRAME_INTERVAL) {
        queueFrame();
        return;
      }
      var dt = lastTs ? Math.min(ts - lastTs, 100) : 16;
      lastTs = ts;
      lastPaintTs = ts;

      spawnAcc += dt;
      while (spawnAcc >= SPAWN_EVERY) {
        spawnAcc -= SPAWN_EVERY;
        var n = 1 + Math.floor(Math.random() * 2);
        for (var k = 0; k < n; k++) {
          cells[Math.floor(Math.random() * cells.length)] = 1;
        }
      }

      var decay = Math.pow(0.5, dt / HALF_LIFE);
      ctx.clearRect(0, 0, W, H);
      for (var i = 0; i < cells.length; i++) {
        var a = cells[i];
        if (a <= 0.012) { cells[i] = 0; continue; }
        var x = (i % cols) * conf.cell;
        var y = Math.floor(i / cols) * conf.cell;
        ctx.globalAlpha = a;
        ctx.fillStyle = conf.colors[i % conf.colors.length];
        ctx.fillRect(x, y, conf.cell, conf.cell);
        cells[i] = a * decay;
      }
      ctx.globalAlpha = 1;
      queueFrame();
    }

    function syncRunning() {
      var shouldRun = isIntersecting && !document.hidden && !reducedMotion.matches;
      if (shouldRun === running) return;
      running = shouldRun;
      if (running) {
        lastTs = 0;
        lastPaintTs = 0;
        queueFrame();
      }
    }

    var vis = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        isIntersecting = e.isIntersecting;
        syncRunning();
      });
    }, { threshold: 0.05 });
    vis.observe(canvas);
    document.addEventListener('visibilitychange', syncRunning);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', syncRunning);
    else if (reducedMotion.addListener) reducedMotion.addListener(syncRunning);
  }

  function initAll(scope) {
    scope = scope || document;
    if (scope.matches) {
      // when scope is a section element, include it in the lookups
      var lookup = function (sel) {
        var list = Array.prototype.slice.call(scope.querySelectorAll(sel));
        if (scope.matches(sel)) list.unshift(scope);
        return list;
      };
      lookup('[data-problems]').forEach(initTabs);
      lookup('.fcard').forEach(initFcard);
      lookup('[data-timeline]').forEach(initTimeline);
      lookup('[data-timeline]').forEach(initTimelinePhotos);
      lookup('[data-dl-mobile-marquee]').forEach(initMobileMarquee);
      lookup('.faq__item').forEach(initFaqItem);
      lookup('canvas.checker').forEach(initChecker);
    } else {
      scope.querySelectorAll('[data-problems]').forEach(initTabs);
      scope.querySelectorAll('.fcard').forEach(initFcard);
      scope.querySelectorAll('[data-timeline]').forEach(initTimeline);
      scope.querySelectorAll('[data-timeline]').forEach(initTimelinePhotos);
      scope.querySelectorAll('[data-dl-mobile-marquee]').forEach(initMobileMarquee);
      scope.querySelectorAll('.faq__item').forEach(initFaqItem);
      scope.querySelectorAll('canvas.checker').forEach(initChecker);
    }
  }

  initAll(document);

  /* Shopify theme editor: re-init interactions when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    // open the selected FAQ block in the editor for easy editing
    var item = e.target.closest ? e.target.closest('.faq__item') : null;
    if (item) item.classList.add('is-open');
  });
})();
